module.exports = __webpack_public_path__ + "static/media/en-data-roaming-iphone_2.1cfbcfd2.png";